import noop from 'lodash/noop';
import { createActions } from 'redux-actions';
export const teamActions = createActions({
    SELECT_TEAM_MEMBERS_FILTER: [
        (payload) => payload,
        (payload, resolve = noop, reject = noop) => ({ resolve, reject }), // Meta
    ],
}, 'TEAM_TOGGLE_AGENT_DETAILS', 'SET_PRESENCE_FILTERS');
